export enum ErrorCode {
  NoError = 0,
  InternalError = 1,

  InvalidToken = 48401000,
  ExpiredToken = 48401001,

  // OTP
  NeedOTP = 48401102, // Extra OTP verification is required. User will need to go through OTP verification flow.
  OTPChannelUnavailable = 48401103, // Server is busy right now. Please try again later
  ExceedOTPLimit = 48401050,
  ExceedNotiLimit = 48401051,
  InvalidOTP = 48401003,
  ExpiredOTP = 48401001,
  FraudOTP = 48401130,
  SessionNotFound = 48500101,

  // One Credential
  ToCLinked = 48401120,
  ToCUnlinked = 48401121, // ToC account is found with phone, but it does not have corresponding ToB entity with this phone number.
  ToCLinkDisallowed = 48401125,
  PhoneUpdateDisallowed = 48401126, // Returned during account update's changePhone to determine if SPX service determine cannot change phone.
  ToCExist = 48401127, // Returned by create_toc_account when phone number is used on bypass OTP flow
  EmailUpdateDisallowed = 48401129,
  PasswordUpdateDisallowed = 48401172,
  TobOneCredentialNotLinked = 48401188, // ToB one credential not linked
  InvitationLinkInvalid = 48401132,
  InvitationLinkExpired = 48401133,
  InvitationLinkTaken = 48401134,
  RepeatedToCLink = 48401135,
  SwitchToCLinkLimitExceeded = 48401136,
  SwitchToCLinkAttemptExceeded = 48401137,
  DelinkToCInitLimitExceeded = 48401173,
  DelinkToCLimitExceeded = 48401174,

  // Captcha
  NeedCaptcha = 48401112,
  InvalidCaptcha = 48401005,

  // Fraud Login Check
  LoginFraudError = 48401114,

  // Account
  AccountBanned = 48401108,
  AccountDeleted = 48401109,

  // Phone/Email Management
  PhoneTaken = 48401100,
  EmailTaken = 48401106,
  ChangePhoneLimitExceeded = 48401146,
  ChangeEmailLimitExceeded = 48401156,

  // Authentication
  InvalidPassword = 48401004,
  PasswordEmpty = 48401007,
  PasswordNotEmpty = 48401117,
  PhoneNotExist = 48401101,
  UsernameNotExist = 48401105,
  EmailNotExist = 48401107,
  InvalidInput = 10002,
  RegionMismatch = 48401118,
  NotLoggedIn = 19,
  PhoneEmailNotExist = 48401128,
  NeedSetNewPasswordOnInitialLogin = 48401142,
  ForgetPasswordInitLimitExceeded = 48401154,
  VerifyPasswordLimitExceeded = 48401148,

  // Thirdparty
  ThirdpartyBound = 48401175, // tob_userid is bound to a thirdparty id
  ThirdpartyFraudBindShopee = 48401176, // trigger fraud risk check for login/bind case
  ThirdpartyNotBound = 48401177, // current account is not bound to the thirdparty id
  ThirdpartyFraudUnbindShopee = 48401178, // trigger fraud risk check for unbind case
  ThirdpartyNoPermission = 48401179, // shopee auth client id is not whitelisted by ToB BE
  ThirdpartyTokenInvalid = 48401180, // thirdparty token is invalid
  ThirdpartyExisted = 48401181, // thirdparty id is bound to a tob_userid (the purpose of this code is different from ThirdpartyBound)
  TobLinked = 48401182, // Shopee account is already linked to another existing account
  BindThirdpartyTokenInvalid = 48401192, // bind_third_party_token is invalid
  ThirdpartyFraudBindGoogle = 48401193, // Rule Engine blocks binding for Google
  ThirdpartyFraudBindFacebook = 48401194, // Rule Engine blocks binding for Facebook
  ThirdpartyFraudBindApple = 48401195, // Rule Engine blocks binding for Apple

  // IVS
  NeedIvs = 48401163, // Extra IVS verification is required. User will need to go through IVS verification flow.
  IvsSignatureValidationFailed = 48401166,
  IvsFlowNoInvalid = 48401167,

  // Service Errors
  NotFound = 10013,

  // FE Error Code
  FeErrorCode = -999,

  // Partner Error Code
  PartnerNotAllowDelinkTocMyStock = 48401191,

  // SP Portal Error Code
  SpPortalAccountDisabled = 48401197,

  // Cooldown Error Code
  ErrorLoginWarnLimitReached = 48401139, // user reaches J incorrect password login attempts within Y minutes
  ErrorLoginLimitExceeded = 48401140, // user exceeds X incorrect password login attempts within Y minutes
  ErrorLoginOnCooldown = 48401141, // user is on cooldown for password login rate limit
}
